import React from 'react';
function Chevron() {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
			<path className="icon-chevron" d="M50,100C22.4,100,0,77.6,0,50S22.4,0,50,0s50,22.4,50,50S77.6,100,50,100z M50,4.9C25.1,4.9,4.9,25.1,4.9,50c0,24.9,20.2,45.1,45.1,45.1S95.1,74.9,95.1,50C95.1,25.1,74.9,4.9,50,4.9z"/>
			<path className="icon-chevron" d="M50,63.2c-0.6,0-1.3-0.2-1.7-0.7L26.9,41c-1-1-1-2.5,0-3.5s2.5-1,3.5,0L50,57.2l19.7-19.7c1-1,2.5-1,3.5,0c1,1,1,2.5,0,3.5L51.7,62.4C51.3,62.9,50.6,63.2,50,63.2z"/>
		</svg>
	);
}
export default Chevron;


/** WEBPACK FOOTER **
 ** ./src/modules/images/Chevron.js
 **/